// extracted by mini-css-extract-plugin
export var button = "Button-module--button--edc40";
export var isLoading = "Button-module--isLoading--74a1f";
export var secondary = "Button-module--secondary--7e305";